const translations = {
  nav_about: "Sobre nós",
  nav_services: "Serviços",
  nav_method: "Método",
  nav_library: "Biblioteca",
  nav_contact: "Contacto",
  nav_login: "Entrar",
  nav_register: "Registar",
  nav_my_profile: "O meu perfil",
  nav_availability: "Estado de disponibilidade",
  nav_processes: "Os meus processos",
  nav_edit: "Editar informação",
  nav_privacy: "Política de privacidade",
  nav_logout: "Terminar sessão",
  nav_company_account: "Conta empresarial",
  nav_professional_account: "Conta profissional",
  hero_badge: "International Placement",
  hero_title_1: "Seleção estratégica de talento na Europa",
  hero_title_2: "International Placement",
  hero_subtitle: "Empresa estratégica de seleção e colocação internacional na Europa.",
  hero_markets: "Alemanha · Suíça · Países Baixos · Áustria · Bélgica",
  hero_cta_talent: "Procurar talento",
  hero_cta_explore: "Explorar oportunidades",
  hero_social_proof: "+120 profissionais colocados na Europa",
};

export default translations;
